/**
 * v4b registrations — countertops, vent hoods, fireplace, procedural
 * mirror. Cabinets (the rest of the original v4 tier) live in
 * v4a-registrations.js and ship in a parallel PR.
 *
 * Kept as a separate file so each tier-agent can land independently
 * without merge conflicts; `index.js` will eventually import every
 * vN-registrations file.
 */
import { registerSchematic } from './registry';
import { CountertopSchematic } from './CountertopSchematic';
import { VentHoodSchematic } from './VentHoodSchematic';
import { FireplaceSchematic } from './FireplaceSchematic';
import { MirrorSchematic } from './MirrorSchematic';

registerSchematic('countertop', CountertopSchematic);
registerSchematic('vent-hood', VentHoodSchematic);
registerSchematic('fireplace', FireplaceSchematic);
registerSchematic('mirror', MirrorSchematic);

export {
  CountertopSchematic,
  VentHoodSchematic,
  FireplaceSchematic,
  MirrorSchematic,
};
